import {axios} from "@/utilites/api";
import Config from "@/common/config";

const getClients = (parameters) => {
    const url = new URL(`${Config.apiURL}/settings/clients/titles/${parameters.type}?userId=${parameters.id}&all=${parameters.all}`)
    if (parameters.params) {
        Object.entries(parameters.params).forEach(([key, value]) => {
            if (value || value === false) url.searchParams.append(key, value)
        })
    }
    return axios.get(url)
}

const clientCopy = (parameters) => {
    return axios.post(`${Config.apiURL}/settings/clients/copy?fromId=${parameters.id}&userId=${parameters.userId}`)
}

const shareClient = (parameters) => {
    return axios.post(`${Config.apiURL}/settings/clients/share`, parameters)
}

const transferToClient = (parameters) => {
    return axios.post(`${Config.apiURL}/settings/clients/transfer?id=${parameters.id}&userId=${parameters.userId}&transferUserId=${parameters.transferUserId}`)
}

const lastContactClient = (parameters) => {
    return axios.put(`${Config.apiURL}/settings/clients/contact?id=${parameters.id}&date=${parameters.date}`)
}

const deleteClient = (parameters) => {
    return axios.delete(`${Config.apiURL}/settings/clients?id=${parameters.id}&userId=${parameters.userId}`)
}

export default {
    getClients,
    clientCopy,
    shareClient,
    transferToClient,
    deleteClient,
    lastContactClient
}
